import React, { useState } from 'react';
import { Box, Card, TextField, Button, Typography, Container, Alert, CircularProgress } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { isLoading, error } = useSelector((state) => state.auth);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await dispatch.auth.forgotPasswordAsync({ email });
        if (result?.success) {
            navigate('/verify-otp', { state: { email } });
        }
    };

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', bgcolor: 'primary.dark' }}>
            <Container maxWidth="xs">
                <Card sx={{ p: 4, borderRadius: 3, boxShadow: '0 8px 32px rgba(0,0,0,0.2)' }}>
                    <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <Typography variant="h4" fontWeight="bold" color="primary" gutterBottom>
                            Forgot Password
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Enter your registered email to receive a verification code (OTP).
                        </Typography>
                    </Box>

                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
                    <form onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Email Address"
                            variant="outlined"
                            margin="normal"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                        />
                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            size="large"
                            color="primary"
                            disabled={isLoading || !email}
                            sx={{ mt: 1 }}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Send Reset Link'}
                        </Button>
                    </form>
                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                        <Typography variant="body2">
                            <Link to="/login" style={{ color: '#4f46e5', textDecoration: 'none' }}>
                                Back to Login
                            </Link>
                        </Typography>
                    </Box>
                </Card>
            </Container>
        </Box>
    );
}
